import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { withAppContext, IAppContext } from '../../shared/app-context';
import { localization, LocHelperInstance, langChangedName } from '../../shared/localization/localization';
import { LogoGallery } from '../../shared/components/gallery/logo-gallery.component';
import { DebuggerInstance } from 'src/App/shared/debugger';
import { Markdown } from 'src/App/shared/localization/markdown-wrapper';
import { ReturnUrlQueryParam, LogoUploadUrl, LogoGalleryUrl } from 'src/App/shared/constants';

export interface ILogoDisplayGalleryComponentProps extends RouteComponentProps<void> {
    appContext: IAppContext;
}

export interface ILogoDisplayGalleryComponentState {
    isLoading: boolean;
    returnUrl: string | null;
}

/**
 * Razeni pozic obrazku je na zaklade indexu v 'images'
 */
class LogoDisplayGalleryComponent extends React.PureComponent<ILogoDisplayGalleryComponentProps, ILogoDisplayGalleryComponentState> {
    private langUpdateHandle = () => { this.props.appContext.setTitle(localization.galleryLoc.galleryTitle); };

    constructor(props: ILogoDisplayGalleryComponentProps) {
        super(props);

        const query = new URLSearchParams(this.props.location.search);
        let returnUrl = query.get(ReturnUrlQueryParam);
        if (returnUrl) {
            returnUrl = decodeURIComponent(returnUrl);
        }

        this.state = {
            isLoading: false,
            returnUrl
        };
    }

    public componentDidMount() {
        LocHelperInstance.langChanged.addListener(langChangedName, this.langUpdateHandle);        
        this.langUpdateHandle();
    }

    public componentWillUnmount() {
        LocHelperInstance.langChanged.removeListener(langChangedName, this.langUpdateHandle);
    }

    private handleEmptyGallery(): void {
        this.props.history.push('/logo/upload?no-image=true');
    }

    private handleImageSelected(id: string): void {
        DebuggerInstance.log('handleImageSelected');
        this.props.appContext.onLogochanged(id);

        if (this.state.returnUrl) {
            DebuggerInstance.log(`returning to url:`);
            DebuggerInstance.log(this.state.returnUrl);
            this.props.history.push(this.state.returnUrl);
        } else {
            this.props.appContext.closeApp();
        }
    }

    private getUploadBtnUrl(): string {
        let returnUrl = `${LogoUploadUrl}?${ReturnUrlQueryParam}=${LogoGalleryUrl}`;
        if (this.state.returnUrl) {
            returnUrl = `${LogoUploadUrl}?${ReturnUrlQueryParam}=${encodeURIComponent(this.state.returnUrl)}`;   
        }

        DebuggerInstance.log('getUploadBtnUrl');
        DebuggerInstance.log(returnUrl)
        return returnUrl;
    }

    private clearSelectedLogo(): void {
        DebuggerInstance.log('handleImageSelected');
        this.props.appContext.onLogochanged('');
        this.props.appContext.closeApp();
    }

    public render() {
        return (
            <div className="logo-display-gallery-root">
                <div className="container">
                    <div className="row row-info">
                        <span><Markdown text={localization.galleryLoc.galleryInfo} /></span>
                    </div>
                    <div className="row">
                        <div className="gallery-content">
                            <LogoGallery
                                showDeleteBtn={true}
                                excludeMotives={false}
                                onLogoSelected={(id) => this.handleImageSelected(id)}
                                onEmptyGallery={() => this.handleEmptyGallery()}
                                logoTitle={localization.galleryLoc.logoImageHint}
                            />
                        </div>
                    </div>
                    <div className="row lg-row-buttons">
                        <button className="common-link-button" onClick={() => window.open(localization.commonLoc.controlsLinkValue)}>
                            <Markdown text={localization.galleryLoc.controlsLinkTitle} />
                        </button>
                        <Link to={this.getUploadBtnUrl()}>
                            <button className="main-button primary-style">
                                <Markdown text={localization.galleryLoc.uploadNewLogo} />
                            </button>
                        </Link>
                        <button className="clear-selected-logo" onClick={() => this.clearSelectedLogo()}>{localization.galleryLoc.clearSelectedLogo}</button>
                    </div>
                </div>
            </div>
        );
    }
}

export const LogoDisplayGallery = withAppContext(LogoDisplayGalleryComponent);



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-gallery/logo-gallery.component.tsx